<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm-title" id="fm-8"><a id="page_xxxiii"><em>Abbreviations</em></a></h1><a id="page_xxxiii">
<table>
<tbody>
<tr>
<td class="td2"><p class="t-left"><em>ABD</em></p></td>
<td><p class="t-left"><em>Anchor Bible Dictionary,</em> ed. D. N. Freedman</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><span class="awit">ʿ</span><em>Abod. Zar.</em></p></td>
<td><p class="t-left"><span class="awit">ʿ</span><em>Aboda Zara</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><span class="awit">ʾ</span><em>Abot. R. Nat.</em></p></td>
<td><p class="t-left"><span class="awit">ʾ</span><em>Abot de Rabbi Nathan</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Abr.</em></p></td>
<td><p class="t-left"><em>De Abrahamo</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Ach74</p></td>
<td><p class="t-left">Achaea inscription no. 74</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Add. Esth.</p></td>
<td><p class="t-left">Additions to Esther</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>AE</em></p></td>
<td><p class="t-left"><em>Année Epigraphique</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Aet.</em></p></td>
<td><p class="t-left"><em>De Aeternitate Mundi</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Ag. Ap.</em></p></td>
<td><p class="t-left"><em>Against Apion</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Agr.</em></p></td>
<td><p class="t-left"><em>De Agricultura</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>AJA</em></p></td>
<td><p class="t-left"><em>American Journal of Archaeology</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>AJS Review</em></p></td>
<td><p class="t-left"><em>Association for Jewish Studies Review</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>ANET</em></p></td>
<td><p class="t-left"><em>Ancient Near Eastern Texts Relating to the Old Testament</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Anim.</em></p></td>
<td><p class="t-left"><em>De Animalibus</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>ANRW</em></p></td>
<td><p class="t-left"><em>Aufstieg und Niedergang der römischen Welt,</em> ed. H. Temporini and W. Haase</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Ant.</em></p></td>
<td><p class="t-left"><em>Antiquities of the Jews</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>AOT</em></p></td>
<td><p class="t-left"><em>The Apocryphal Old Testament,</em> ed. H. F. D. Sparks</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>ap</em></p></td>
<td><p class="t-left">Apocryphon (e.g., 1QapGen)</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>APAT</em></p></td>
<td><p class="t-left"><em>Die Apokryphen und Pseudepigraphen des Alten Testmanents,</em> ed. E. Kautzsch</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Apoc. Abr.</em></p></td>
<td><p class="t-left"><em>Apocalypse of Abraham</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Apoc. Mos.</em></p></td>
<td><p class="t-left"><em>Apocalypse of Moses</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Apoc. Sedr.</em></p></td>
<td><p class="t-left"><em>Apocalypse of Sedrach</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Apoc. Zeph.</em></p></td>
<td><p class="t-left"><em>Apocalypse of Zephaniah</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>APOT</em></p></td>
<td><p class="t-left"><em>The Apocrypha and Psuedepigrapha of the Old Testament,</em> ed. R. H. Charles</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">ar</p></td>
<td><p class="t-left">Aramaic (e.g., 4QMess ar)</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><span class="awit">ʿ</span><em>Arak.</em></p></td>
<td><p class="t-left"><span class="awit">ʿ</span><em>Arakin</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Aram.</p></td>
<td><p class="t-left">Aramaic</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>As. Mos.</em></p></td>
<td><p class="t-left"><em>Assumption of Moses</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Asc. Isa.</em></p></td>
<td><p class="t-left"><em>Ascension of Isaiah</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>ASTI</em></p></td>
<td><p class="t-left"><em>Annual of the Swedish Theological Institute</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>b.</em></p></td>
<td><p class="t-left">Babylonian Talmud tractate</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>B. Bat.</em></p></td>
<td><p class="t-left"><em>Baba Batra</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>B. Me</em><span class="awit">ṣ</span><em>.</em></p></td>
<td><p class="t-left"><em>Baba Me</em><span class="awit">ṣ</span><em>i</em><span class="awit">ʿ</span><em>a</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>B. Qam.</em></p></td>
<td><p class="t-left"><em>Baba Qamma</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>BA</em></p></td>
<td><p class="t-left"><em>Biblical Archaeologist</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>BAR</em></p></td>
<td><p class="t-left"><em>Biblical Archaeology Review</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Bar.</p></td>
<td><p class="t-left">Baruch</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>2 Bar.</em></p></td>
<td><p class="t-left"><em>2 Baruch (Syriac Apocalypse)</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>3 Bar.</em></p></td>
<td><p class="t-left"><em>3 Baruch (Greek Apocalypse)</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>4 Bar.</em></p></td>
<td><p class="t-left"><em>4 Baruch (Paraleipomena Jeremiou)</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Barn.</em></p></td>
<td><p class="t-left"><em>Barnabas</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>BASOR</em></p></td>
<td><p class="t-left"><em>Bulletin of the American Schools of Oriental Research</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><span class="smallcaps">B.C.E.</span></p></td>
<td><p class="t-left">Before the Common Era</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>BCH</em></p></td>
<td><p class="t-left"><em>Bulletin de correspondance hellénique</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Bek.</em></p></td>
<td><p class="t-left"><em>Bekorot</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Benj.</em></p></td>
<td><p class="t-left"><em>Benjamin</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Ber.</em></p></td>
<td><p class="t-left"><em>Berakot</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>BGU</em></p></td>
<td><p class="t-left"><em>Berliner Griechische Urkunden</em> (Ägyptische Urkunden aus den Königlichen Museen zu Berlin), Berlin, 1895-1912</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Bib</em></p></td>
<td><p class="t-left"><em>Biblica</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Bib. Ant.</em></p></td>
<td><p class="t-left"><em>Biblical Antiquities (Liber Antiquitatum Biblicarum)</em> of Pseudo-Philo</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Bik.</em></p></td>
<td><p class="t-left"><em>Bikkurim</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>BIOSCS</em></p></td>
<td><p class="t-left"><em>Bulletin of the International Organization for Septuagint and Cognate Studies</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>BJRL</em></p></td>
<td><p class="t-left"><em>Bulletin of the John Rylands University Library</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>BR</em></p></td>
<td><p class="t-left"><em>Biblical Research</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>BSOAS</em></p></td>
<td><p class="t-left"><em>Bulletin of the School of Oriental and African Studies</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">ca.</p></td>
<td><p class="t-left">circa</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">C. Ord. Ptol.</p></td>
<td><p class="t-left">Corpus des Ordonnances des Ptolémées</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><span class="smallcaps">C.E</span>.</p></td>
<td><p class="t-left">Common Era</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Cant.</p></td>
<td><p class="t-left">Canticles</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>CAP</em></p></td>
<td><p class="t-left"><em>Aramaic Papyri of the Fifth Century <span class="smallcaps">B.C.</span>,</em> ed. A. E. Cowley, Oxford: Oxford University Press, 1923 (cited by document number)</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>CBQ</em></p></td>
<td><p class="t-left"><em>Catholic Biblical Quarterly</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>CBR</em></p></td>
<td><p class="t-left"><em>Currents in Biblical Research</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">CCSG</p></td>
<td><p class="t-left">Corpus Christianorum: Series Graeca</p></td>
</tr>
</tbody>
</table>
</a><p class="indent-para"><a id="page_xxxiii"></a><a id="page_xxxiv"></a></p><a id="page_xxxiv">
<table>
<tbody>
<tr>
<td class="td2"><p class="t-left">CD</p></td>
<td><p class="t-left">Cairo Genizah copy of the <em>Damascus Document</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">chap(s).</p></td>
<td><p class="t-left">chapter(s)</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Cher.</em></p></td>
<td><p class="t-left"><em>De Cherubim</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>CHJ</em></p></td>
<td><p class="t-left"><em>Cambridge History of Judaism</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Chron.</p></td>
<td><p class="t-left">Chronicles</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>CIG</em></p></td>
<td><p class="t-left"><em>Corpus Inscriptionum Graecarum,</em> ed. A. Boeckh, 4 vols., Berlin, 1828-1877</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>CIJ</em></p></td>
<td><p class="t-left"><em>Corpus Inscriptionum Judaicarum,</em> ed. J.-B. Frey, Vatican City: Pontificio istituto di archeologia cristiana, 1936-52</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>CIL</em></p></td>
<td><p class="t-left"><em>Corpus Inscriptionum Latinarum,</em> 18 vols., Berlin, 1862-1989</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>CIS</em></p></td>
<td><p class="t-left"><em>Corpus Inscriptionum Semiticarum</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>CJZC</em></p></td>
<td><p class="t-left"><em>Corpus jüdischer Zeugnisse aus der Cyrenaika,</em> ed. G. Lüderitz, Wiesbaden: Reichert, 1983</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>1 Clem.</em></p></td>
<td><p class="t-left"><em>1 Clement</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>2 Clem.</em></p></td>
<td><p class="t-left"><em>2 Clement</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">cm(s).</p></td>
<td><p class="t-left">centimeter(s)</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">col(s).</p></td>
<td><p class="t-left">column(s)</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Col.</p></td>
<td><p class="t-left">Colossians</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Conf.</em></p></td>
<td><p class="t-left"><em>De Confusione Linguarum</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Congr.</em></p></td>
<td><p class="t-left"><em>De Congressu Eruditionis Gratia</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Cont.</em></p></td>
<td><p class="t-left"><em>De Vita Contemplativa</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Cor.</p></td>
<td><p class="t-left">Corinthians</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>CPJ</em></p></td>
<td><p class="t-left"><em>Corpus Papyrorum Judaicarum,</em> ed. V. Tcherikover and A. Fuks, 3 vols., Cambridge: Harvard University Press, 1957-1964</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Dan.</p></td>
<td><p class="t-left">Daniel</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Decal.</em></p></td>
<td><p class="t-left"><em>De Decalogo</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Dem.</em></p></td>
<td><p class="t-left"><em>Demai</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Det.</em></p></td>
<td><p class="t-left"><em>Quod Deterius Potiori Insidiari Solea</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Deus</em></p></td>
<td><p class="t-left"><em>Quod Deus Sit Immutabilis</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Deut.</p></td>
<td><p class="t-left">Deuteronomy</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Dial.</em></p></td>
<td><p class="t-left"><em>Dialogue with Trypho the Jew</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">DJD</p></td>
<td><p class="t-left">Discoveries in the Judaean Desert</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>DSD</em></p></td>
<td><p class="t-left"><em>Dead Sea Discoveries</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">DSS</p></td>
<td><p class="t-left">Dead Sea Scrolls</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Ebr.</em></p></td>
<td><p class="t-left"><em>De Ebrietate</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Eccl.</p></td>
<td><p class="t-left">Ecclesiastes</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">ed.</p></td>
<td><p class="t-left">edited by, edition</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">e.g.</p></td>
<td><p class="t-left"><em>exempli gratia</em> (for example)</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><span class="awit">ʿ</span><em>Ed.</em></p></td>
<td><p class="t-left"><span class="awit">ʿ</span><em>Eduyyot</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Egyp.</p></td>
<td><p class="t-left">Egyptian</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>EncJud</em></p></td>
<td><p class="t-left"><em>Encyclopedia Judaica</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Eng.</p></td>
<td><p class="t-left">English</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">ep.</p></td>
<td><p class="t-left">epistle</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Ep. Arist.</em></p></td>
<td><p class="t-left"><em>Epistle of Aristeas</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Ep. Jer.</p></td>
<td><p class="t-left">Epistle of Jeremiah</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Eph.</p></td>
<td><p class="t-left">Ephesians</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><span class="awit">ʿ</span><em>Erub.</em></p></td>
<td><p class="t-left"><span class="awit">ʿ</span><em>Erubin</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Esdr.</p></td>
<td><p class="t-left">Esdras</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">esp.</p></td>
<td><p class="t-left">especially</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">et al.</p></td>
<td><p class="t-left"><em>et alii</em> (and the others)</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">etc.</p></td>
<td><p class="t-left"><em>et cetera</em> (and the rest)</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>EvT</em></p></td>
<td><p class="t-left"><em>Evangelische Theologie</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Exod.</p></td>
<td><p class="t-left">Exodus</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>ExpTim</em></p></td>
<td><p class="t-left"><em>Expository Times</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Ezek.</p></td>
<td><p class="t-left">Ezekiel</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">f(f).</p></td>
<td><p class="t-left">following pages, lines, verses, etc.</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">fl.</p></td>
<td><p class="t-left">flourished</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Flacc.</em></p></td>
<td><p class="t-left"><em>In Flaccum</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">fol(s).</p></td>
<td><p class="t-left">folio(s)</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">frg(s).</p></td>
<td><p class="t-left">fragment(s)</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Frg. Tg.</p></td>
<td><p class="t-left">Fragment Targum</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Fr.</p></td>
<td><p class="t-left">French</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Fug.</em></p></td>
<td><p class="t-left"><em>De Fuga et Inventione</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Gal.</p></td>
<td><p class="t-left">Galatians</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">GCS</p></td>
<td><p class="t-left">Die griechische christliche Schriftsteller</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Gen.</p></td>
<td><p class="t-left">Genesis</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Geog.</em></p></td>
<td><p class="t-left"><em>Geography</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Ger.</p></td>
<td><p class="t-left">German</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Gig.</em></p></td>
<td><p class="t-left"><em>De Gigantibus</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Gi</em><span class="awit">ṭ</span></p></td>
<td><p class="t-left"><em>Gi</em><span class="awit">ṭ</span><em></em><span class="awit">ṭ</span><em>in</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>GLAJJ</em></p></td>
<td><p class="t-left"><em>Greek and Latin Authors on Jews and Judaism</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Gr.</p></td>
<td><p class="t-left">Greek</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Hab.</p></td>
<td><p class="t-left">Habbakuk</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Hag.</p></td>
<td><p class="t-left">Haggai</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><span class="awit">ḥ</span><em>ag.</em></p></td>
<td><p class="t-left"><span class="awit">ḥ</span><em>agiga</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><span class="awit">ḥ</span><em>al.</em></p></td>
<td><p class="t-left"><span class="awit">ḥ</span><em>allah</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Heb.</p></td>
<td><p class="t-left">Epistle to the Hebrews</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Hebr.</p></td>
<td><p class="t-left">Hebrew</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Hekh. Rab.</em></p></td>
<td><p class="t-left"><em>Hekhalot Rabbati</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Her.</em></p></td>
<td><p class="t-left"><em>Quis Rerum Divinarum Heres Sit</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><span class="f1">Ḥ</span>ev.</p></td>
<td><p class="t-left">Na<span class="f1">ḥ</span>al <span class="f1">Ḥ</span>ever</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><span class="f1">Ḥ</span>ev/Se</p></td>
<td><p class="t-left">Na<span class="f1">ḥ</span>al <span class="f1">Ḥ</span>ever documents earlier attributed to Seiyal</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Hist. Eccl.</em></p></td>
<td><p class="t-left"><em>Church History</em> of Eusebius of Caesarea</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Hom. adv. Jud.</em></p></td>
<td><p class="t-left"><em>Homiliae adversus Judaeos</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Hos.</p></td>
<td><p class="t-left">Hosea</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>HSCP</em></p></td>
<td><p class="t-left"><em>Harvard Studies in Classical Philology</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>HTR</em></p></td>
<td><p class="t-left"><em>Harvard Theological Review</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>HUCA</em></p></td>
<td><p class="t-left"><em>Hebrew Union College Annual</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><span class="awit">ḥ</span><em>ul.</em></p></td>
<td><p class="t-left"><span class="awit">ḥ</span><em>ullin</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Hypoth.</em></p></td>
<td><p class="t-left"><em>Hypothetica</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>ICS</em></p></td>
<td><p class="t-left"><em>Illinois Classical Studies</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">i.e.</p></td>
<td><p class="t-left"><em>id est</em> (that is)</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>IEJ</em></p></td>
<td><p class="t-left"><em>Israel Exploration Journal</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>IGRR</em></p></td>
<td><p class="t-left"><em>Inscriptiones Graece ad Res Romanas Pertinentes</em> (1901-1927)</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>IJO</em></p></td>
<td><p class="t-left"><em>Inscriptiones Judaicae Orientis,</em> ed. D. Noy et al., 3 vols., Tübingen: Mohr-Siebeck, 2004</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>ILS</em></p></td>
<td><p class="t-left"><em>Inscriptiones Latinae Selectae,</em> ed. H. Dessau, 3 vols. in 5 pts., Berlin, 1892-1916</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>INJ</em></p></td>
<td><p class="t-left"><em>Israel Numismatics Journal</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Int</em></p></td>
<td><p class="t-left"><em>Interpretation</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>IOS</em></p></td>
<td><p class="t-left"><em>Israel Oriental Society</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Isa.</p></td>
<td><p class="t-left">Isaiah</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Issa.</em></p></td>
<td><p class="t-left"><em>Issachar</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>JAAR</em></p></td>
<td><p class="t-left"><em>Journal of the American Academy of Religion</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>JANES</em></p></td>
<td><p class="t-left"><em>Journal of the Ancient Near Eastern Society</em></p></td>
</tr>
</tbody>
</table>
</a><p class="t-left"><a id="page_xxxiv"></a><a id="page_xxxv"></a></p><a id="page_xxxv">
<table>
<tbody>
<tr>
<td class="td2"><p class="t-left"><em>JAOS</em></p></td>
<td><p class="t-left"><em>Journal of the American Oriental Society</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Jas.</p></td>
<td><p class="t-left">James</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>JBL</em></p></td>
<td><p class="t-left"><em>Journal of Biblical Literature</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>JBT</em></p></td>
<td><p class="t-left"><em>Jahrbuch für biblische Theologie</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">JDS</p></td>
<td><p class="t-left">Jewish Desert Studies</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Jdt.</p></td>
<td><p class="t-left">Judith</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>JECS</em></p></td>
<td><p class="t-left"><em>Journal of Early Christian Studies</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Jer.</p></td>
<td><p class="t-left">Jeremiah</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>JIGRE</em></p></td>
<td><p class="t-left"><em>Jewish Inscriptions of Graeco-Roman Egypt,</em> ed. W. Horbury and D. Noy, Cambridge: Harvard University Press, 1992</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>JJS</em></p></td>
<td><p class="t-left"><em>Journal of Jewish Studies</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>JNES</em></p></td>
<td><p class="t-left"><em>Journal of Near Eastern Studies</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Jos.</em></p></td>
<td><p class="t-left"><em>De Josepho</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Jos. &amp; Asen.</em></p></td>
<td><p class="t-left"><em>Joseph and Aseneth</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Josh.</p></td>
<td><p class="t-left">Joshua</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>JQR</em></p></td>
<td><p class="t-left"><em>Jewish Quarterly Review</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>JR</em></p></td>
<td><p class="t-left"><em>Journal of Religion</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>JRA</em></p></td>
<td><p class="t-left"><em>Journal of Roman Archaeology</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>JRRW</em></p></td>
<td><p class="t-left"><em>Jewish Rights in the Roman World: The Greek and Roman Documents Quoted by Josephus Flavius,</em> ed. M. Pucci Ben Zeev, Tübingen: Mohr-Siebeck, 1998.</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">JSHRZ</p></td>
<td><p class="t-left">Jüdische Schriften aus hellenistischrömischer Zeit</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>JSJ</em></p></td>
<td><p class="t-left"><em>Journal for the Study of Judaism</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">JSJSup</p></td>
<td><p class="t-left">Journal for the Study of Judaism Supplement</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>JSNT</em></p></td>
<td><p class="t-left"><em>Journal for the Study of the New Testament</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>JSOT</em></p></td>
<td><p class="t-left"><em>Journal for the Study of the Old Testament</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>JSP</em></p></td>
<td><p class="t-left"><em>Journal for the Study of the Pseudepigrapha</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>JSQ</em></p></td>
<td><p class="t-left"><em>Jewish Studies Quarterly</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>JSS</em></p></td>
<td><p class="t-left"><em>Journal of Semitic Studies</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>JTS</em></p></td>
<td><p class="t-left"><em>Journal of Theological Studies</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Jub.</em></p></td>
<td><p class="t-left"><em>Jubilees</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Jud.</em></p></td>
<td><p class="t-left"><em>Judah</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Judg.</p></td>
<td><p class="t-left">Judges</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>J.W.</em></p></td>
<td><p class="t-left"><em>Jewish War</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Ker.</em></p></td>
<td><p class="t-left"><em>Keritot</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Ketub.</em></p></td>
<td><p class="t-left"><em>Ketubbot</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">kg.</p></td>
<td><p class="t-left">Kilogram</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Kgdms.</p></td>
<td><p class="t-left">Kingdoms</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">KhQ</p></td>
<td><p class="t-left">Khirbet Qumran</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">km(s).</p></td>
<td><p class="t-left">kilometer(s)</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Kourion</p></td>
<td><p class="t-left"><em>The Inscriptions of Kourion,</em> T. B. Mitford, Philadelphia: American Philosophical Society, 1971</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>LAB</em></p></td>
<td><p class="t-left"><em>Liber Antiquitatum Biblicarum</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Lam.</p></td>
<td><p class="t-left">Lamentations</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Lat.</p></td>
<td><p class="t-left">Latin</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">LCL</p></td>
<td><p class="t-left">Loeb Classical Library</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Leg. Alleg.</em></p></td>
<td><p class="t-left"><em>Legum Allegoriae</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Legat.</em></p></td>
<td><p class="t-left"><em>Legatio ad Gaium</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Lev.</p></td>
<td><p class="t-left">Leviticus</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">lit.</p></td>
<td><p class="t-left">literally</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Liv. Pro.</em></p></td>
<td><p class="t-left"><em>Lives of the Prophets</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">LXX</p></td>
<td><p class="t-left">Septuagint</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">m.</p></td>
<td><p class="t-left">meter</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>m.</em></p></td>
<td><p class="t-left">Mishnah tractate</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Ma</em><span class="awit">ʿ</span><em>aś.</em></p></td>
<td><p class="t-left"><em>Ma</em><span class="awit">ʿ</span><em>aśerot</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Ma</em><span class="awit">ʿ</span><em>aś. Š.</em></p></td>
<td><p class="t-left"><em>Ma</em><span class="awit">ʿ</span><em>aśer Šeni</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Macc.</p></td>
<td><p class="t-left">Maccabees</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Magn.</em></p></td>
<td><p class="t-left"><em>To the Magnesians</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Mak.</em></p></td>
<td><p class="t-left"><em>Makkot</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Makš.</em></p></td>
<td><p class="t-left"><em>Makširim</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Mal.</p></td>
<td><p class="t-left">Malachi</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Mart. Isa.</em></p></td>
<td><p class="t-left"><em>Martyrdom of Isaiah</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Mart. Pol.</em></p></td>
<td><p class="t-left"><em>Martyrdom of Polycarp</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Mas</p></td>
<td><p class="t-left">Masada</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">MasŠirŠabb</p></td>
<td><p class="t-left"><em>Songs of the Sabbath Sacrifice</em> fragments from Masada</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Matt.</p></td>
<td><p class="t-left">Matthew</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Meg.</em></p></td>
<td><p class="t-left"><em>Megilla</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Mek.</em></p></td>
<td><p class="t-left"><em>Mekilta</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Mena</em><span class="awit">ḥ</span><em>.</em></p></td>
<td><p class="t-left"><em>Mena</em><span class="awit">ḥ</span><em>ot</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">mg.</p></td>
<td><p class="t-left">margin</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Mic.</p></td>
<td><p class="t-left">Micah</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Mid.</em></p></td>
<td><p class="t-left"><em>Middot</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Midr.</em></p></td>
<td><p class="t-left"><em>Midraš (Midrash)</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Migr.</em></p></td>
<td><p class="t-left"><em>De Migratione Abrahami</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Miqw.</em></p></td>
<td><p class="t-left"><em>Miqwa</em><span class="awit">ʾ</span><em>ot</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Mird</p></td>
<td><p class="t-left">Khirbet Mird</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">MMT</p></td>
<td><p class="t-left"><em>Miq</em><span class="awit">ṣ</span><em>at Ma</em><span class="awit">ʿ</span><em>aśê ha-Torah</em> or <em>Some of the Works of the Law</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Mos.</em></p></td>
<td><p class="t-left"><em>Moses</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">ms(s).</p></td>
<td><p class="t-left">manuscript(s)</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Mt.</p></td>
<td><p class="t-left">Mount</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">MT</p></td>
<td><p class="t-left">Masoretic Text</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Mur</p></td>
<td><p class="t-left">Murabba<span class="f1">ʿ</span>at</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Murray</p></td>
<td><p class="t-left"><em>Excavations in Cyprus,</em> A. S. Murray et al., London: British Museum, 1900</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Mut.</em></p></td>
<td><p class="t-left"><em>De Mutatione Nominum</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">n.</p></td>
<td><p class="t-left">note</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Nah.</p></td>
<td><p class="t-left">Nahum</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Naph.</em></p></td>
<td><p class="t-left"><em>Naphtali</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Ned.</em></p></td>
<td><p class="t-left"><em>Nedarim</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Neg.</em></p></td>
<td><p class="t-left"><em>Nega</em><span class="awit">ʿ</span><em>im</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Neh.</p></td>
<td><p class="t-left">Nehemiah</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Neotest</em></p></td>
<td><p class="t-left"><em>Neotestamentica</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Nez.</em></p></td>
<td><p class="t-left"><em>Neziqin</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">NHC</p></td>
<td><p class="t-left">Nag Hammadi Codex</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Nid.</em></p></td>
<td><p class="t-left"><em>Niddah</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">NJPS</p></td>
<td><p class="t-left"><em>Tanakh: The Holy Scriptures.</em> New Jewish Publication Society Translation</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">nos.</p></td>
<td><p class="t-left">numbers</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>NovT</em></p></td>
<td><p class="t-left"><em>Novum Testamentum</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">N.S.</p></td>
<td><p class="t-left">new series</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>NTS</em></p></td>
<td><p class="t-left"><em>New Testament Studies</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Num.</p></td>
<td><p class="t-left">Numbers</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">O.</p></td>
<td><p class="t-left">Ostracon</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Obad.</p></td>
<td><p class="t-left">Obadiah</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">OG</p></td>
<td><p class="t-left">Old Greek</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>OGIS</em></p></td>
<td><p class="t-left"><em>Orientis Graeci Inscriptiones Selectae,</em> 2 vols., ed. W. Dittenberger, Leipzig: Hirzel, 1903-1905</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Ohol.</em></p></td>
<td><p class="t-left"><em>Oholot</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">OL</p></td>
<td><p class="t-left">Old Latin</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><a id="page_xxxvi">OLP</a></p></td>
<td><p class="t-left">Orientalia Lovaniensia Periodica</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Opif.</em></p></td>
<td><p class="t-left"><em>De Opifìcio Mundi</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Opusc. Arch.</em></p></td>
<td><p class="t-left"><em>Opuscula Archaeologica</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><span class="awit">ʿ</span><em>Or.</em></p></td>
<td><p class="t-left"><span class="awit">ʿ</span><em>Orlah</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>OTP</em></p></td>
<td><p class="t-left"><em>Old Testament Pseudepigrapha,</em> 2 vols., ed. J. H. Charlesworth</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">p(p).</p></td>
<td><p class="t-left">page(s)</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">P.</p></td>
<td><p class="t-left">Papyrus</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>P.Dion.</em></p></td>
<td><p class="t-left"><em>Dionysios Papyri = Les archives privés de Dionysios, fils de Kephalas,</em> ed. P. W. Pestman and E. Boswinkel, Leiden: Brill, 1982</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>P.Harris</em></p></td>
<td><p class="t-left"><em>The Rendell Harris Papyri of Woodbrooke College, Birmingham,</em> ed. J. E. Powell, Cambridge: Cambridge University Press, 1936</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>P.Teb.</em></p></td>
<td><p class="t-left"><em>The Tebtunis Papyri,</em> ed. B. P. Grenfell, A. S. Hunt, and J. G. Smyly, London: Henry Frowde, 1902</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>PAAJR</em></p></td>
<td><p class="t-left"><em>Proceedings of the American Academy of Jewish Research</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">paleo</p></td>
<td><p class="t-left">Paleo-Hebrew (e.g., 11QpaleoLev)</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">PAM</p></td>
<td><p class="t-left">Palestine Archaeological Museum</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Pan.</em></p></td>
<td><p class="t-left">Epiphanius of Salamis, <em>Panarion</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">pap.</p></td>
<td><p class="t-left">Papyrus (e.g., 4QpapParaExod gr)</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Bib</p></td>
<td><p class="t-left">Biblica</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">para.</p></td>
<td><p class="t-left">paraphrase</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">par(s).</p></td>
<td><p class="t-left">parallel(s)</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>PEQ</em></p></td>
<td><p class="t-left"><em>Palestine Exploration Quarterly</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Pesa</em><span class="awit">ḥ</span><em>.</em></p></td>
<td><p class="t-left"><em>Pesa</em><span class="awit">ḥ</span><em>im</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Pesiq. R.</em></p></td>
<td><p class="t-left"><em>Pesiqta Rabbati</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Pesiq. Rab Kah.</em></p></td>
<td><p class="t-left"><em>Pesiqta de Rab Kahana</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">1 Pet.</p></td>
<td><p class="t-left">1 Peter</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>PG</em></p></td>
<td><p class="t-left"><em>Patrologia Graeca</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>PGM</em></p></td>
<td><p class="t-left"><em>Papyri Graecae Magicae,</em> 3 vols., ed. K. Preisendanz, Leipzig: Teubner, 1928-1941</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Phil.</p></td>
<td><p class="t-left">Philippians</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Phld.</em></p></td>
<td><p class="t-left"><em>To the Philadelphians</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Pirqe R. El.</em></p></td>
<td><p class="t-left"><em>Pirqe Rabbi Eliezer</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>PL</em></p></td>
<td><p class="t-left"><em>Patrologia Latina</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">pl(s).</p></td>
<td><p class="t-left">plate(s)</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Plant.</em></p></td>
<td><p class="t-left"><em>De Plantatione</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Post.</em></p></td>
<td><p class="t-left"><em>De Posteritate Caini</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Pr. Azar.</p></td>
<td><p class="t-left">Prayer of Azariah</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Pr. Man.</p></td>
<td><p class="t-left">Prayer of Manasseh</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Praem.</em></p></td>
<td><p class="t-left"><em>De Praemiis et Poenis</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Praep. Evang.</em></p></td>
<td><p class="t-left"><em>Praeparatio Evangelica</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Prob.</em></p></td>
<td><p class="t-left"><em>Quod Omnis Probus Liber Sit</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Prov.</em></p></td>
<td><p class="t-left"><em>De Providentia</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Prov.</p></td>
<td><p class="t-left">Proverbs</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Ps(s).</p></td>
<td><p class="t-left">Psalm(s)</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Ps.-</p></td>
<td><p class="t-left">Pseudo-</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Ps.-Clem. <em>Hom.</em></p></td>
<td><p class="t-left">Pseudo-Clementine <em>Homilies</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Ps.-Clem. <em>Recog.</em></p></td>
<td><p class="t-left">Pseudo-Clementine <em>Recognitions</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Q</p></td>
<td><p class="t-left">Qumran</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">1Q, 2Q, etc.</p></td>
<td><p class="t-left">Numbered caves of Qumran</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">1QapGen</p></td>
<td><p class="t-left"><em>Genesis Apocryphon</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">1QH</p></td>
<td><p class="t-left"><em>Hodayot</em> or <em>Thanksgiving Hymns</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">1QIsa<sup>a, b</sup></p></td>
<td><p class="t-left">Isaiah Scrolls</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">1QM</p></td>
<td><p class="t-left"><em>Mil</em><span class="awit">ḥ</span><em>amah</em> or <em>War Scroll</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">1QpHab</p></td>
<td><p class="t-left"><em>Habakkuk Pesher</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">1QS</p></td>
<td><p class="t-left"><em>Serek Haya</em> <span class="awit">ḥ</span> <em>ad</em> or <em>Rule of the Community</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">1QSa</p></td>
<td><p class="t-left"><em>Rule of the Congregation</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">1QSb</p></td>
<td><p class="t-left"><em>Rule of Blessings</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">4QMMT</p></td>
<td><p class="t-left"><em>Miqsat Ma</em><span class="awit">ʿ</span><em>aśêha-Torah</em> or <em>Some of the Works of the Law</em> from Qumran Cave 4</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">11QMelch</p></td>
<td><p class="t-left"><em>Melchizedek Scroll</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">11QPs<sup>a</sup></p></td>
<td><p class="t-left"><em>Psalms Scroll<sup>a</sup></em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">11QTemple</p></td>
<td><p class="t-left"><em>Temple Scroll</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Qídd.</em></p></td>
<td><p class="t-left"><em>Qiddušin</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>QE</em></p></td>
<td><p class="t-left"><em>Quaestiones et Solutiones in Exodum</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>QG</em></p></td>
<td><p class="t-left"><em>Quaestiones et Solutiones in Genesim</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Qod.</em></p></td>
<td><p class="t-left"><em>Qodašin</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Qoh.</p></td>
<td><p class="t-left">Qoheleth</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Rab.</em></p></td>
<td><p class="t-left"><em>Rabbah</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>RB</em></p></td>
<td><p class="t-left"><em>Revue biblique</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>REJ</em></p></td>
<td><p class="t-left"><em>Revue des études juives</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Reub.</em></p></td>
<td><p class="t-left"><em>Reuben</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Rev.</p></td>
<td><p class="t-left">Revelation</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">rev. ed.</p></td>
<td><p class="t-left">revised edition</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>RevQ</em></p></td>
<td><p class="t-left"><em>Revue de Qumran</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>RHPR</em></p></td>
<td><p class="t-left"><em>Revue d’histoire et de philosophie religieuses</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Rom.</p></td>
<td><p class="t-left">Romans</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Rom.</em></p></td>
<td><p class="t-left"><em>To the Romans</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Roš Haš.</em></p></td>
<td><p class="t-left"><em>Roš Haššanah</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">rpt.</p></td>
<td><p class="t-left">reprint</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>RQ</em></p></td>
<td><p class="t-left"><em>Römische Quartalschrift</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>RSR</em></p></td>
<td><p class="t-left"><em>Recherches de science religieuse</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>S.</em> <span class="awit">ʿ</span><em>Olam Rab.</em></p></td>
<td><p class="t-left"><em>Seder</em> <span class="awit">ʿ</span><em>Olam Rabbah</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Šab.</em></p></td>
<td><p class="t-left"><em>Šabbat</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Sacr.</em></p></td>
<td><p class="t-left"><em>De Sacrificiis Abelis et Caini</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Salamis</em></p></td>
<td><p class="t-left"><em>The Greek and Latin Inscriptions from Salamis,</em> ed. Terence B. Mitford and Ino K. Nicolaou, Nicosia: Department of Antiquities, 1974</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Sam.</p></td>
<td><p class="t-left">Samuel</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Sanh.</em></p></td>
<td><p class="t-left"><em>Sanhedrin</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>SB V</em></p></td>
<td><p class="t-left"><em>Sammelbuch griechischer Urkunden aus Ägypten,</em> vol. 5, ed. E. Kiessling, Wiesbaden, 1950</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>SBLSP</em></p></td>
<td><p class="t-left"><em>Society of Biblical Literature Seminar Papers</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">sc.</p></td>
<td><p class="t-left"><em>scilicet</em> (namely)</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>SCI</em></p></td>
<td><p class="t-left"><em>Scripta Classica Israelica</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Šeb.</em></p></td>
<td><p class="t-left"><em>Šebi<span class="awit">ʿ</span>it</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Šebu.</em></p></td>
<td><p class="t-left"><em>Šebu</em><span class="awit">ʿ</span><em>ot</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>SEG</em></p></td>
<td><p class="t-left"><em>Supplementum Epigraphicum Graecum</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Šeqal.</em></p></td>
<td><p class="t-left"><em>Šeqalim</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Sib. Or.</em></p></td>
<td><p class="t-left"><em>Sibylline Oracles</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Sif. me</em><span class="awit">ṣ</span><em>. zab.</em></p></td>
<td><p class="t-left"><em>Sifra me</em><span class="awit">ṣ</span><em>ora</em><span class="awit">ʿ</span><em>zabim</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Sim.</em></p></td>
<td><p class="t-left"><em>Simeon</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Sin.</p></td>
<td><p class="t-left">Sinaiticus</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Sir.</p></td>
<td><p class="t-left">Sirach</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>ŠirŠabb</em></p></td>
<td><p class="t-left"><em>Šîrôt</em> <span class="awit">ʿ</span><em>Ôlat Haššabbat (Songs of the Sabbath Sacrifice)</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>SJOT</em></p></td>
<td><p class="t-left"><em>Scandinavian Journal of the Old Testament</em></p></td>
</tr>
</tbody>
</table>
</a><p class="t-left"><a id="page_xxxv"></a><a id="page_xxxvii"></a></p><a id="page_xxxvii">
<table>
<tbody>
<tr>
<td class="td2"><p class="t-left"><em>SJT</em></p></td>
<td><p class="t-left"><em>Scottish Journal of Theology</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Sobr.</em></p></td>
<td><p class="t-left"><em>De Sobrietate</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Somn.</em></p></td>
<td><p class="t-left"><em>De Somniis</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Sop.</p></td>
<td><p class="t-left"><em>Soperim</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">SP</p></td>
<td><p class="t-left">Sacra Pagina</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Spec. Leg.</em></p></td>
<td><p class="t-left"><em>De Specialibus Legibus</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>SPhA</em></p></td>
<td><p class="t-left"><em>Studia Philonica Annual</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>SR</em></p></td>
<td><p class="t-left"><em>Studies in Religion</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Sukk.</em></p></td>
<td><p class="t-left"><em>Sukka</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Sus.</p></td>
<td><p class="t-left">Susanna</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>SVF</em></p></td>
<td><p class="t-left"><em>Stoicorum Veterum Fragmenta,</em> 4 vols., ed. H. F. A. von Armin, Leipzig: Teubner, 1902-1904</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>t.</em></p></td>
<td><p class="t-left">Tosefta tractate</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>T.</em></p></td>
<td><p class="t-left"><em>Testament</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>T. 12. Patr.</em></p></td>
<td><p class="t-left"><em>Testaments of the Twelve Patriarchs</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Ta</em><span class="awit">ʿ</span><em>an.</em></p></td>
<td><p class="t-left"><em>Ta</em><span class="awit">ʿ</span><em>anit</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>T. Abr.</em></p></td>
<td><p class="t-left"><em>Testament of Abraham</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>TAD</em></p></td>
<td><p class="t-left"><em>Textbook of Aramaic Documents from Ancient Egypt,</em> ed. B. Porten and A. Yardeni, Jerusalem: Hebrew University, 1986-1999</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"> </p></td>
<td><p class="t-left"><em>TAD</em> A = vol. 1, <em>Letters</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"> </p></td>
<td><p class="t-left"><em>TAD</em> B = vol. 2, <em>Contracts</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"> </p></td>
<td><p class="t-left"><em>TAD</em> C = vol. 3, <em>Literature and Lists</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"> </p></td>
<td><p class="t-left"><em>TAD</em> D = vol. 4, <em>Ostraca and Assorted</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"> </p></td>
<td><p class="t-left"><em>Inscriptions</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>TBT</em></p></td>
<td><p class="t-left"><em>The Bible Today</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>TDNT</em></p></td>
<td><p class="t-left"><em>Theological Dictionary of the New Testament,</em> 10 vols., ed. G. Kittel and G. Friedrich, Grand Rapids: Eerdmans, 1964-1976</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Ter.</em></p></td>
<td><p class="t-left"><em>Terumot</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">tg</p></td>
<td><p class="t-left">Targum (e.g., 11QtgJob)</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Tg. Jer.</em></p></td>
<td><p class="t-left"><em>Targum Jeremiah</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Tg. Neof.</em></p></td>
<td><p class="t-left"><em>Targum Neofiti</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Tg. Onq.</em></p></td>
<td><p class="t-left"><em>Targum Onqelos</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Tg. Ps.-J.</em></p></td>
<td><p class="t-left"><em>Targum Pseudo-Jonathan</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Thess.</p></td>
<td><p class="t-left">Thessalonians</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Tim.</p></td>
<td><p class="t-left">Timothy</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Tob.</p></td>
<td><p class="t-left">Tobit</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Tohor.</em></p></td>
<td><p class="t-left"><em>Tohorot</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">trans.</p></td>
<td><p class="t-left">translated by, translation</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>TS</em></p></td>
<td><p class="t-left"><em>Theological Studies</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>TZ</em></p></td>
<td><p class="t-left"><em>Theologische Zeitschrift</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>USQR</em></p></td>
<td><p class="t-left"><em>Union Seminary Quarterly Review</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">v(v).</p></td>
<td><p class="t-left">verse(s)</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>VC</em></p></td>
<td><p class="t-left"><em>Vigiliae Christianae</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>VF</em></p></td>
<td><p class="t-left"><em>Verkundigung und Forschung</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Virt.</em></p></td>
<td><p class="t-left"><em>De Virtutibus</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">vol.</p></td>
<td><p class="t-left">volume</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">vs.</p></td>
<td><p class="t-left">versus</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>VT</em></p></td>
<td><p class="t-left"><em>Vetus Testamentum</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">WDSP</p></td>
<td><p class="t-left">Wadi Daliyeh Samaria Papyri</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Wis.</p></td>
<td><p class="t-left">Wisdom of Solomon</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">y.</p></td>
<td><p class="t-left">Palestinian (Jerusalem) Talmud tractate</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Yad.</em></p></td>
<td><p class="t-left"><em>Yadayim</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Yebam.</em></p></td>
<td><p class="t-left"><em>Yebamot</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>ZAW</em></p></td>
<td><p class="t-left"><em>Zeitschrift für die alttestamentliche Wissenschaft</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Zeb.</em></p></td>
<td><p class="t-left"><em>Zebulun</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Zeba</em><span class="awit">ḥ</span><em>.</em></p></td>
<td><p class="t-left"><em>Zeba</em><span class="awit">ḥ</span><em>im</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Zech.</p></td>
<td><p class="t-left">Zechariah</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left">Zeph.</p></td>
<td><p class="t-left">Zephaniah</p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>Zer.</em></p></td>
<td><p class="t-left"><em>Zera</em><span class="awit">ʿ</span><em>im</em></p></td>
</tr>
<tr>
<td class="td2"><p class="t-left"><em>ZNW</em></p></td>
<td><p class="t-left"><em>Zeitschrift für die neutestamentliche Wissenschaft</em></p></td>
</tr>
</tbody>
</table>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 013_Abbreviations.vue?2e3f7538